import { themeColor } from "./_helpers";

export const borderTokens = {
  default: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.dark.500}",
    _themeWhite: "{colors.neutral.200}",
  }),
  muted: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.neutral.100}",
  }),
  strong: themeColor({
    base: "{colors.neutral.300}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.300}",
  }),
  focus: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.600}",
  }),
  error: themeColor({
    base: "{colors.red.500}",
    _themeBlack: "{colors.red.400}",
    _themeWhite: "{colors.red.500}",
  }),
};
